import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, Sparkles } from "lucide-react";

export default function EmailCapture() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="email-capture" className="bg-navy border-y border-copper/25 py-16 lg:py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2">
          <Sparkles size={14} className="text-copper" strokeWidth={2} />
          <span className="eyebrow">Join the List</span>
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl text-sand mt-4 leading-tight">
          Get <span className="text-copper italic">20% off</span> your first order.
        </h2>
        <p className="mt-4 text-base text-sand/75 leading-relaxed font-light">
          Sign up with your email and we&apos;ll send your discount code — plus early access to new drops and Texarkana specials.
        </p>

        {done ? (
          <div data-testid="email-capture-success" className="mt-8 inline-flex items-center gap-3 border border-copper/50 bg-black/30 px-6 py-4">
            <Check size={20} className="text-copper flex-shrink-0" />
            <span className="text-sand text-sm sm:text-base">
              You&apos;re in! Use code <span className="text-copper font-semibold tracking-wide">WELCOME20</span> at checkout for 20% off.
            </span>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              data-testid="email-capture-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 bg-black border border-copper/40 px-4 py-3.5 text-sand placeholder:text-sand/40 focus:border-copper focus:outline-none"
            />
            <button
              type="submit"
              data-testid="email-capture-submit"
              disabled={loading}
              className="bg-copper text-navy px-7 py-3.5 text-sm uppercase tracking-[0.18em] font-semibold hover:bg-[#E5C158] transition-colors disabled:opacity-60 whitespace-nowrap"
            >
              {loading ? "Signing up…" : "Get 20% Off"}
            </button>
          </form>
        )}
        <p className="mt-4 text-xs text-sand/40">No spam. Unsubscribe anytime. Must be 21+.</p>
      </div>
    </section>
  );
}
